var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 488 248",
    viewBox: "0 0 488 248",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e33e44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ec6370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f07140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ee927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d192b1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(1 0 0 -1 0 248)",
    gradientUnits: "userSpaceOnUse",
    x1: 135,
    x2: 277.4,
    xlinkHref: "#a",
    y1: 179.7,
    y2: 179.7
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 248)",
    gradientUnits: "userSpaceOnUse",
    x1: 79.95,
    x2: 109.0019,
    xlinkHref: "#a",
    y1: 105.4997,
    y2: 105.4997
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientTransform: "matrix(1 0 0 -1 0 248)",
    gradientUnits: "userSpaceOnUse",
    x1: 293.1,
    x2: 420.9,
    xlinkHref: "#a",
    y1: 189.5,
    y2: 189.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m137 78v158c0 .6.4 1 1 1h136.4c.6 0 1-.4 1-1v-158zm48 33c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5zm38.4 29.4-.1.1c-.8.8-2.1.7-2.8-.1-.3-.3-.6-.6-.9-.9-7.7-7.2-19.8-6.8-27.1.9s-.1.1-.1.1c-.8.8-2.1.7-2.8-.1-.8-.9-.8-2.2 0-3 .3-.4.7-.7 1-1 9.3-8.8 24-8.3 32.8 1 .8.8.8 2.1 0 3zm4.6-29.4c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m153.6 175.9h104.4c1.2.1 2.2-.7 2.3-1.9s-.7-2.2-1.9-2.3c-.1 0-.3 0-.4 0h-104.4c-1.2-.1-2.2.7-2.3 1.9s.7 2.2 1.9 2.3zm0 14.7h104.4c1.2.1 2.2-.7 2.3-1.9s-.7-2.2-1.9-2.3c-.1 0-.3 0-.4 0h-104.4c-1.2-.1-2.2.7-2.3 1.9s.7 2.2 1.9 2.3zm0 14.6h104.4c1.2.1 2.2-.7 2.3-1.9s-.7-2.2-1.9-2.3c-.1 0-.3 0-.4 0h-104.4c-1.2-.1-2.2.7-2.3 1.9s.7 2.2 1.9 2.3zm0 14.7h57.6c1.2.1 2.2-.7 2.3-1.9s-.7-2.2-1.9-2.3c-.1 0-.3 0-.4 0h-57.6c-1.2-.1-2.2.7-2.3 1.9s.7 2.2 1.9 2.3z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m138 60.8h136.4c1.7 0 3 1.3 3 3v9c0 1.7-1.3 3-3 3h-136.4c-1.7 0-3-1.3-3-3v-9c0-1.6 1.3-3 3-3z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m142 66.2c1.5 0 2.7 1.2 2.7 2.7s-1.2 2.7-2.7 2.7-2.7-1.2-2.7-2.7 1.2-2.7 2.7-2.7zm7.4 0c-1.5 0-2.7 1.2-2.7 2.7s1.2 2.7 2.7 2.7 2.7-1.2 2.7-2.7-1.3-2.7-2.7-2.7zm7.3 0c-1.5 0-2.6 1.2-2.7 2.7 0 1.5 1.2 2.7 2.7 2.7s2.7-1.2 2.6-2.7c0-1.5-1.2-2.7-2.6-2.7zm28.3 34.8c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5zm43 0c2.8 0 5 2.2 5 5s-2.2 5-5 5-5-2.2-5-5 2.2-5 5-5zm-37.4 35.3c-.4.3-.7.7-1 1-.8.9-.8 2.2 0 3s2 .9 2.8.1l.1-.1c7.2-7.7 19.4-8.1 27.1-.9l.9.9c.8.8 2 .9 2.8.1l.1-.1c.8-.9.8-2.2 0-3-8.8-9.3-23.4-9.8-32.8-1zm135 49.8-19.6-107.5c-.2-1.1-1.3-1.9-2.5-1.7-1.1.2-1.9 1.3-1.7 2.5l19.4 106.5c-8.8 5.4-15.8 5.2-22.4.3-5.3-3.9-9-9.1-17-22.1l-2-3.2c-.1-.2-.3-.4-.5-.5v-82.4-4-10c0-2.8-2.2-5-5-5h-136.3c-2.8 0-5 2.2-5 5v10 4 83.2l-1.9 3c-8 13-11.7 18.1-17 22-6.7 4.9-13.8 5.1-22.9-.6-1-.6-2.3-.3-2.9.6s-.4 2.2.5 2.8c0 0 .1 0 .1.1 10.5 6.6 19.6 6.5 27.7.5 5.5-4 9.2-9 16.4-20.4v67c0 2.8 2.2 5 5 5h136.4c2.8 0 5-2.2 5-5v-67.9c7.5 12.1 11.3 17.2 17 21.4 8.1 6 17.1 6.2 27.7-.5.4-.2.6-.5.8-.9.5-.6.8-1.4.7-2.2zm-188.6-122.1c0-.6.4-1 1-1h136.4c.6 0 1 .4 1 1v10h-138.4zm137.4 173h-136.4c-.6 0-1-.4-1-1v-158h138.4v158c0 .6-.5 1-1 1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m92.1 168c2.7-.1 4.8-2.3 4.7-5s-2.3-4.8-5-4.7-4.8 2.3-4.7 5c0 .8.3 1.6.7 2.3.9 1.5 2.6 2.5 4.3 2.4zm16.9-38.2c0 1.8-.3 3.6-.9 5.2-.5 1.3-1.3 2.6-2.2 3.7-1.1 1.2-2.3 2.3-3.6 3.4-1.8 1.5-3.3 3.1-4.7 5-1.1 1.8-1.6 3.9-1.5 6v1.4h-8.1v-1.4c-.1-2.2.3-4.4 1.1-6.5.6-1.6 1.5-3.2 2.7-4.5 1.2-1.4 2.6-2.7 4-3.9 1.5-1.2 2.8-2.5 4-4 .9-1.2 1.3-2.7 1.3-4.2s-.7-3-1.9-4c-1.2-1.1-3.2-1.6-6-1.6-3.7.1-7.4 1.2-10.6 3.1l-2.6-7c2.3-1.1 4.6-2 7.1-2.6 2.3-.6 4.6-.9 7-.9 3.9-.1 7.6 1 10.8 3.3 2.7 2.2 4.1 5.3 4.1 9.5z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m293.1 30.2 114.3-20.2 13.5 76.8-114.2 20.2z",
    fill: "url(#d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m380.3 58.5 6.5-1.2-1.8-10.1zm15.9-2.8.8 4.4-4.4.8 1.1 6-5.1.9-1.1-6-12.7 2.2-.6-3.4 8.8-20.2 5.9-1 3 17.2zm-37.4 13.1c1.9-.2 3.5-1.6 4.1-3.5.6-2.4.7-4.8.2-7.2-.3-2.4-1.2-4.7-2.6-6.6-2-2.3-5.4-2.5-7.6-.5-.7.6-1.2 1.3-1.5 2.1-.6 2.3-.7 4.8-.2 7.1.3 2.4 1.2 4.8 2.6 6.8 1.2 1.6 3.1 2.3 5 1.8zm-4.1-23.7c3.8-.7 6.8.1 9.1 2.4 2.5 2.7 4.1 6 4.6 9.6.8 3.6.4 7.3-1 10.6-1.4 3-4 4.8-7.7 5.5s-6.8-.2-9.2-2.5c-2.5-2.6-4.1-6-4.6-9.6-.8-3.6-.4-7.3 1.1-10.6 1.3-2.9 3.9-4.7 7.7-5.4zm-29 23 6.5-1.2-1.8-10.2zm16-2.8.8 4.4-4.4.8 1.1 6-5.1.9-1.1-6-12.8 2.2-.6-3.4 8.8-20.2 5.9-1 3 17.2z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.2484588db93cc3ebe948c0a63baf48fd.svg";
export { ForwardRef as ReactComponent };